import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_BASE } from '../config';
import { useAuth } from '../context/AuthContext';  // Importar el hook para obtener el token
import '../styles/datos.css';

const Datos = () => {
  const { scanCode } = useParams();  // Obtener el código escaneado de la URL
  const { token } = useAuth();  // Obtener el token desde el contexto de autenticación
  const [rack, setRack] = useState('');
  const [shelf, setShelf] = useState('');
  const [skuCode, setSkuCode] = useState('');
  const [quantity, setQuantity] = useState('');
  const [isPickZone, setIsPickZone] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [expirationDate, setExpirationDate] = useState('');
  const navigate = useNavigate();

  // Extraer rack y shelf del código escaneado en la URL
  useEffect(() => {
    if (scanCode) {
      const [rack, shelf] = scanCode.split('-'); // Separar el código escaneado por el guion
      setRack(rack);
      setShelf(shelf);
    }
  }, [scanCode]);

  // Enviar los datos al API
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if shelf starts with A or B and picking is false
    if ((shelf.startsWith('A') || shelf.startsWith('B')) && !isPickZone) {
      setShowWarning(true);
      return;
    }

    await submitData();
  };

  const submitData = async () => {
    const payload = {
      sku_code: skuCode.trim(),
      quantity: Number(quantity),
      rack: rack,
      shelf: shelf,
      picking: isPickZone,
    };

    // Only include expiration_date if it's provided
    if (expirationDate) {
      payload.expiration_date = expirationDate;
    }

    console.log('Datos enviados:', payload);

    try {
      const response = await fetch(`${API_BASE}/add-stock/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Respuesta del servidor:', data);
        alert('Datos enviados correctamente.');
        navigate('/storage');
      } else {
        const errorText = await response.text();
        console.error('Error:', errorText);
        alert('Error al enviar los datos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      alert('Error de conexión.');
    }
  };


  return (
    <div className="datos-container">
      {showWarning && (
        <div className="warning-modal">
          <div className="warning-content">
            <h3>Cuidado estas ingresando almacenaje a zona de picking.</h3>
            <div className="warning-buttons">
              <button
                className="warning-continue-btn"
                onClick={() => {
                  setShowWarning(false);
                  submitData();
                }}
              >
                Continuar
              </button>
              <button
                className="warning-back-btn"
                onClick={() => setShowWarning(false)}
              >
                Volver
              </button>
            </div>
          </div>
        </div>
      )}

      <button
        className="back-button"
        onClick={() => navigate('/storage/ingreso')}
        style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '8px' }}
      >
        <span className="arrow">&larr;</span>
      </button>

      <h2 className="datos-title">Detalles de Ubicación</h2>

      <div className="datos-location">
        <p className="datos-text"><strong>Rack:</strong> {rack}</p>
        <p className="datos-text"><strong>Shelf:</strong> {shelf}</p>
      </div>

      <form className="datos-form" onSubmit={handleSubmit}>
        <label className="datos-label" htmlFor="skuCode">SKU Code</label>
        <input
          type="text"
          id="skuCode"
          className="datos-input"
          value={skuCode}
          onChange={(e) => setSkuCode(e.target.value)}
          required
        />

        <label className="datos-label" htmlFor="quantity">Cantidad</label>
        <input
          type="number"
          id="quantity"
          className="datos-input"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          required
        />

        <label className="datos-label" htmlFor="expirationDate">Fecha de Vencimiento</label>
        <input
          type="date"
          id="expirationDate"
          className="datos-input"
          value={expirationDate}
          onChange={(e) => setExpirationDate(e.target.value)}
        />

        <label className="datos-label">
          <input
            type="checkbox"
            checked={isPickZone}
            onChange={() => setIsPickZone(!isPickZone)}
          />
          Zona de Pickeo
        </label>

        <button type="submit" className="datos-submit-btn">Enviar</button>
      </form>
    </div>
  );
};

export default Datos;
